import { MutationTree } from 'vuex';

import { MutationTypes } from './mutation-types';
import { DetailViewMode, State } from './state';

export type Mutations<S = State> = {
	[MutationTypes.routeTo](state: S, path: string): void;
	[MutationTypes.toggleMap](state: S): void;
	[MutationTypes.setMapVisible](state: S, value: boolean): void;
	[MutationTypes.toggleSearchBar](state: S): void;
	[MutationTypes.setAppView](state: S, value: boolean): void;
	[MutationTypes.detailViewChangeMode](state: S, mode: DetailViewMode): void;
	[MutationTypes.detailViewSelectMarker](
		state: S,
		payload?: {
			selectedMarker: string | number | null;
			mode?: DetailViewMode;
		}
	): void;
};

export const mutations: MutationTree<State> & Mutations = {
	[MutationTypes.routeTo](state, path: string): void {
		state.currentRoutePath = path;
		state.detailView = {};
	},
	[MutationTypes.toggleMap](state): void {
		state.isMapVisible = !state.isMapVisible;
	},
	[MutationTypes.setMapVisible](state, value: boolean): void {
		state.isMapVisible = value;
	},
	[MutationTypes.toggleSearchBar](state): void {
		state.isSearchToggled = !state.isSearchToggled;
	},
	[MutationTypes.setAppView](state, value: boolean): void {
		state.isAppView = value;
	},
	[MutationTypes.detailViewChangeMode](state, mode: DetailViewMode): void {
		state.detailView = { ...state.detailView, mode };
	},
	[MutationTypes.detailViewSelectMarker](
		state,
		payload: {
			selectedMarker?: string | number | null;
			mode?: DetailViewMode;
		} = {}
	): void {
		const { selectedMarker, mode: modeFromPayload } = payload;

		// defaultMode is 'full' if mode is not set in payload
		let mode: DetailViewMode = modeFromPayload ?? 'full';

		// set mode to null, if selectedMarker is null
		if (selectedMarker == null) {
			mode = null;
		}

		state.detailView = { ...state.detailView, selectedMarker, mode };
	}
};
